import { render, staticRenderFns } from "./PaidRappel.vue?vue&type=template&id=1805df2d"
import script from "./PaidRappel.vue?vue&type=script&lang=js"
export * from "./PaidRappel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports